<ng-container *ngIf="{
  row: columnData | async
} as $">

  <p-tag *ngIf="$.row?.status?.toLowerCase() === 'active'"
    styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="success">{{ $.row.status }}
  </p-tag>
  <p-tag *ngIf="$.row?.status?.toLowerCase() === 'inactive'"
    styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">{{ $.row.status }}
  </p-tag>
  <p-tag *ngIf="$.row?.status?.toLowerCase() === 'completed'" severity="success"
    styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap">{{ $.row.status }}
  </p-tag>
  <p-tag *ngIf="$.row?.status?.toLowerCase() === 'created'" severity="info"
    styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">{{ $.row.status }}
  </p-tag>

  <p-tag *ngIf="$.row?.status?.toLowerCase() === 'presales'"
    styleClass="text-xxs bg-indigo-600 uppercase white-space-nowrap" severity="success">{{$.row.status}}
  </p-tag>

</ng-container>